import api from '@pray/shared/utils/api';

export async function getEmailCampaignStatus({ artistId = '' }) {
  if (!artistId) throw new Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/campaigns/status`;
  const response = await api.executeGetRequest(url);

  return response.data;
}
